import * as React from 'react';
import * as _ from 'lodash';
import { PortfolioAgreementDisclaimer } from './PortfolioAgreementDisclaimer';
import { useDispatch, useSelector } from 'react-redux';
import { portfolioAgreementDisclaimerActions } from '../../actions/portfolio-agreement-disclaimer.actions';
import { AppState } from '../../types/state/AppState';

type TRenderChildren = (blocked: boolean) => React.ReactNode;

interface Props {
    children: React.ReactNode | TRenderChildren;
    disabled?: boolean;
    onConfirm: () => void;
}

export function PortfolioAgreementDisclaimerActionBlocker({ children, onConfirm, disabled = false }: Props) {
    const actionBlockerId = React.useRef(_.uniqueId('portfolio-agreement-disclaimer-action-blocker-'));
    const dispatch = useDispatch();
    const visible = useSelector((state: AppState) => state.portfolioAgreementDisclaimer.visible);
    const confirmed = useSelector((state: AppState) => state.portfolioAgreementDisclaimer.confirmed);
    const blockerId = useSelector((state: AppState) => state.portfolioAgreementDisclaimer.blockerId);
    const handleConfirm = React.useCallback(() => onConfirm(), [onConfirm]);

    React.useEffect(() => {
        if (!visible && actionBlockerId.current === blockerId) {
            if (confirmed) {
                handleConfirm();
            }
            if (confirmed || confirmed === false) {
                dispatch(portfolioAgreementDisclaimerActions.reset());
            }
        }
    }, [visible, actionBlockerId, blockerId, confirmed, dispatch, handleConfirm]);

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        dispatch(portfolioAgreementDisclaimerActions.show(actionBlockerId.current));
    };

    const renderBlocked = () => <div className="display-inline" onClick={handleClick}>{renderChildren(true)}</div>;

    const renderChildren = (blocked: boolean) => {
        if (typeof children === 'function') {
            return (children as TRenderChildren)(blocked);
        }
        return children;
    };

    return (
        <PortfolioAgreementDisclaimer disabled={disabled}>
            {(blocked: boolean) => blocked ? renderBlocked() : renderChildren(false)}
        </PortfolioAgreementDisclaimer>
    );
}
